import { Box, Button } from '@mui/material';
import { NavLink, useMatch } from 'react-router-dom';
import { useGetRuntimeAppQuery } from '@/app/(control-panel)/admin/applications/WorkspaceApi';
import { ViewIcon } from '@/app/(control-panel)/admin/applications/ApplicationDesign';

/** The active application's views share the site's shortcut bar. */
export default function ApplicationNavigation() {
  const match = useMatch('/apps/:id/*');
  const appId = match?.params.id;
  const { currentData: app, isError } = useGetRuntimeAppQuery(appId ?? '', { skip: !appId });

  if (!appId || !app || isError || app.views.length < 2) return null;

  return (
    <Box
      component="nav"
      aria-label={`Views in ${app.name}`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flex: '0 1 auto',
        minWidth: 0,
        gap: 0.5,
        overflowX: 'auto',
        scrollbarWidth: 'thin',
        '& > a': {
          flexShrink: 0,
          minHeight: 36,
          px: 1.25,
          color: 'text.secondary',
          textTransform: 'none',
          whiteSpace: 'nowrap',
          borderBottom: '2px solid transparent',
          borderRadius: '4px 4px 0 0',
        },
        '& > a[aria-current="page"]': {
          color: 'primary.main',
          borderBottomColor: 'primary.main',
          backgroundColor: 'action.selected',
        },
      }}
    >
      {app.views.map((view) => (
        <Button
          key={view.id}
          component={NavLink}
          to={`/apps/${appId}/views/${encodeURIComponent(view.id)}`}
          startIcon={<ViewIcon kind={view.kind} size={16} />}
        >
          {view.title}
        </Button>
      ))}
    </Box>
  );
}
